/**
 * Sucursales (Store Locator) — Map + Cards
 */
(function () {
  'use strict';

  var section = document.querySelector('.le-sucursales');
  if (!section) return;

  var dataEl = document.getElementById('le-stores-data');
  if (!dataEl) return;

  var stores = [];
  try { stores = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var mapEl = document.getElementById('le-stores-map');
  var listEl = section.querySelector('.le-sucursales__list');
  var btnLocation = section.querySelector('[data-action="geolocate"]');
  var btnAll = section.querySelector('[data-action="show-all"]');
  var map = null;
  var markersByIndex = {}; // index → marker
  var infoWindow = null;

  /**
   * Initialize Google Map
   */
  window.__initStoresMap = function () {
    if (!mapEl || !window.google) return;

    var center = { lat: 19.4326, lng: -99.1332 };

    map = new google.maps.Map(mapEl, {
      center: center,
      zoom: 11,
      mapTypeControl: true,
      streetViewControl: false,
      fullscreenControl: true,
      styles: [
        { featureType: 'poi', stylers: [{ visibility: 'off' }] }
      ]
    });

    infoWindow = new google.maps.InfoWindow();
    var bounds = new google.maps.LatLngBounds();
    var hasMarkers = false;

    stores.forEach(function (store, index) {
      if (!store.lat || !store.lng) return;

      var lat = parseFloat(store.lat);
      var lng = parseFloat(store.lng);
      if (isNaN(lat) || isNaN(lng)) return;

      var marker = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: map,
        title: store.name
      });

      markersByIndex[index] = marker;
      bounds.extend(marker.getPosition());
      hasMarkers = true;

      marker.addListener('click', function () {
        selectStore(index);
      });
    });

    if (hasMarkers) {
      map.fitBounds(bounds);
    }

    // Remove placeholder
    var placeholder = mapEl.querySelector('.le-sucursales__map-placeholder');
    if (placeholder) placeholder.style.display = 'none';
  };

  /**
   * Select a store — highlight card, pan map, open info window
   */
  function selectStore(index) {
    var store = stores[index];
    if (!store) return;

    // Highlight card
    var cards = listEl.querySelectorAll('.le-sucursales__card');
    cards.forEach(function (c) { c.classList.remove('le-sucursales__card--active'); });

    var card = listEl.querySelector('[data-store-index="' + index + '"]');
    if (card) {
      card.classList.add('le-sucursales__card--active');
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    // Pan map + info window
    var marker = markersByIndex[index];
    if (map && marker) {
      map.panTo(marker.getPosition());
      map.setZoom(15);

      var mapsUrl = 'https://www.google.com/maps/search/?api=1&query=' +
        encodeURIComponent(store.name + ', ' + (store.address || ''));

      var content = '<div style="font-family:Lato,sans-serif;font-size:13px;max-width:240px">' +
        '<strong>' + store.name + '</strong><br>' +
        (store.address || '') +
        (store.phone ? '<br>' + store.phone : '') +
        '<br><a href="' + mapsUrl + '" target="_blank" rel="noopener" style="color:#007d39;text-decoration:underline;font-size:12px;">Abrir en Google Maps</a>' +
        '</div>';
      infoWindow.setContent(content);
      infoWindow.open(map, marker);
    }
  }

  /**
   * Geolocation — find nearest store
   */
  function geolocate() {
    if (!navigator.geolocation) return;

    btnLocation.textContent = 'Buscando...';
    btnLocation.disabled = true;

    navigator.geolocation.getCurrentPosition(function (pos) {
      var userLat = pos.coords.latitude;
      var userLng = pos.coords.longitude;

      if (map) {
        map.panTo({ lat: userLat, lng: userLng });
        map.setZoom(13);
      }

      // Find nearest store
      var nearest = -1;
      var minDist = Infinity;
      stores.forEach(function (store, i) {
        if (!store.lat || !store.lng) return;
        var dLat = userLat - parseFloat(store.lat);
        var dLng = userLng - parseFloat(store.lng);
        var d = dLat * dLat + dLng * dLng;
        if (d < minDist) { minDist = d; nearest = i; }
      });

      if (nearest >= 0) selectStore(nearest);

      btnLocation.textContent = 'Usar mi ubicación actual';
      btnLocation.disabled = false;
    }, function () {
      btnLocation.textContent = 'Usar mi ubicación actual';
      btnLocation.disabled = false;
      alert('No se pudo obtener tu ubicación. Verificá los permisos del navegador.');
    }, { timeout: 10000 });
  }

  /**
   * Show all stores — fit bounds
   */
  function showAll() {
    if (!map) return;
    var bounds = new google.maps.LatLngBounds();
    var hasMarkers = false;
    Object.keys(markersByIndex).forEach(function (k) {
      bounds.extend(markersByIndex[k].getPosition());
      hasMarkers = true;
    });
    if (hasMarkers) map.fitBounds(bounds);
    if (infoWindow) infoWindow.close();

    var cards = listEl.querySelectorAll('.le-sucursales__card');
    cards.forEach(function (c) { c.classList.remove('le-sucursales__card--active'); });
  }

  // Card click → select store
  if (listEl) {
    listEl.addEventListener('click', function (e) {
      var card = e.target.closest('.le-sucursales__card');
      if (!card) return;
      var index = parseInt(card.getAttribute('data-store-index'), 10);
      if (!isNaN(index)) selectStore(index);
    });
  }

  // Button events
  if (btnLocation) btnLocation.addEventListener('click', geolocate);
  if (btnAll) btnAll.addEventListener('click', showAll);

  // If Google Maps is already loaded
  if (window.google && window.google.maps) {
    window.__initStoresMap();
  }
})();
